"use strict";
// Copyright (c) StrangeBee 2023
Object.defineProperty(exports, "__esModule", { value: true });
exports.functionModeValues = void 0;
exports.functionModeValues = ['Enabled', 'Disabled', 'DryRun'];
